import _ from 'lodash';
import striptags from 'striptags'
import configuration from '../../utils/configuration';

export default {
  validMessageContent
};

function validMessageContent(payload) {
  let { message, assets, price } = payload;
  let limit = _.toNumber(configuration.get('configData.chatroom_message_attachments_count_limit'));
  if (assets.length > limit) {
    return {
      status: false,
      message: `You can't upload more than ${limit} files!`,
    };
  }
  
  message = striptags(message?.trim() || '')?.trim()
  limit = _.toNumber(configuration.get('configData.chatroom_message_text_length_limit'));
  if (message.length === 0) {
    return {
      status: false,
      message: `Message is required!`
    };
  }
  if (message.length > limit) {
    return {
      status: false,
      message: `Message can't have more than ${limit} characters!`,
    };
  }

  limit = _.toNumber(configuration.get('configData.chatroom_message_lock_payment_limit'));
  if (limit && price && price > limit) {
    return {
      status: false,
      message: `Price cannot be greater than $${limit}!`
    };
  }

  return { status: true, message: null };
}
